import axios from "axios";
import { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

// COMPONENTS
import TopForm from "../components/TopForm";
import BodyQuestionsResponses from "../components/BodyQuestionsResponses";

const FormEdit = () => {
  const location = useLocation();
  const history = useHistory();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [name, setName] = useState(location.state.name); // name of my form
  const [list, setList] = useState([]); // list of questions

  // i load my form with questions :
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `https://tellmemore-mahe.herokuapp.com/form/${location.state._id}`
        );
        setData(response.data);
        setList(response.data.questions);
        setIsLoading(false);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, []);

  // onClick : edit by id the name of form
  const handleSubmit = (event) => {
    event.preventDefault();
    if (!name) {
      console.log("nom du formulaire obligatoire");
    } else {
      const fetchUpdate = async () => {
        const formData = new FormData();
        formData.append("name", name);
        try {
          const response = await axios.post(
            `https://tellmemore-mahe.herokuapp.com/form/${data._id}/edit`,
            formData
          );
          setData(response.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error.response.data);
        }
      };
      fetchUpdate();
    }
  };

  // onClick : Add input empty for text question
  const addTextQst = () => {
    const newList = [...list];
    newList.push({ name: "", type: "text" });
    setList(newList);
  };

  // onClick : Add input empty for note question
  const addNoteQst = () => {
    const newList = [...list];
    newList.push({ name: "", type: "note" });
    setList(newList);
  };

  // onClick : save the edit of qst
  const handleSaveData = async () => {
    try {
      const response = await axios.post(
        `https://tellmemore-mahe.herokuapp.com/form/${data._id}/edit`,
        {
          name,
          questions: list,
        }
      );
      setData(response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  // onClick : delete form with id and move to home screen
  const handleDeleteForm = (event) => {
    event.preventDefault();
    console.log(data.data);
    if (data._id) {
      const fetchData = async () => {
        const id = data._id;
        try {
          const response = await axios.post(
            `https://tellmemore-mahe.herokuapp.com/form/${id}/delete`
          );
          console.log(response);
          history.push("/");
        } catch (error) {
          console.log(error.response.data);
        }
      };
      fetchData();
    } else {
      console.log("l'id du formulaire est mal renseigné");
    }
  };

  return !isLoading ? (
    <div className="form form-edit margin50">
      <TopForm
        data={data}
        handleSubmit={handleSubmit}
        handleDeleteForm={handleDeleteForm}
        name={name}
        setName={setName}
      />

      <BodyQuestionsResponses
        addTextQst={addTextQst}
        addNoteQst={addNoteQst}
        list={list}
        setList={setList}
        data={data}
        handleSaveData={handleSaveData}
      />
    </div>
  ) : (
    <div>en cours de chargement</div>
  );
};

export default FormEdit;
